// extracted by mini-css-extract-plugin
export default {"fieldContainer":"AddPartnerModal_fieldContainer__Vmakf","label":"AddPartnerModal_label__jZPNw"};